// extracted by mini-css-extract-plugin
export default {"testRow":"WNk2sduVwy8fAVLvMAIz","resultDateCell":"tC3jKBdcqcx3rgY1rwwK","addNewBtnContainer":"SBzjVwxcbCqf0IWMxVj8"};